import flatten from 'lodash/flatten'
import { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { iOption } from '../../interfaces/iOption'
import { selectDynamEnum } from '../../redux/dynamEnum/dynamEnumSelectors'
import { selectFormIsFullInit } from '../../redux/formTree/formTreeSelectors'
import { scopeWithoutRepeat } from '../../utils/scopeModifs'
import { useElementContext } from '../context/ElementContext'
import { iElementEnumDynamic } from '../interfaces/iElement'

export const useElementEnumDynamic = (): iElementEnumDynamic => {
  const isFullInit = useSelector(selectFormIsFullInit)
  const { uiSchema } = useElementContext()
  const dynamicEnum = uiSchema.options?.dynamEnum ?? []
  const isDynamicEnum = !!dynamicEnum.length

  const enums = useSelector(selectDynamEnum, shallowEqual)

  const dynamicEnumOptions = useMemo(() => {
    if (!isDynamicEnum) return []
    return findDynamicEnum(dynamicEnum, enums)
  }, [isDynamicEnum, dynamicEnum, enums])

  const dynEnum = isFullInit ? dynamicEnumOptions : undefined

  return useMemo(
    () => ({
      dynamicEnumOptions: dynEnum,
      // dynamicEnumLoading: dbEnumLoading,
      isDynamicEnum: isDynamicEnum,
    }),
    [dynEnum, isDynamicEnum],
  )
}

const findDynamicEnum = (dynamicEnum: { scope: string }[], enums: { [scope: string]: iOption[] }) => {
  const enumsOption = dynamicEnum.map((d) => {
    if (enums[d.scope]) {
      return enums[d.scope].map(e=>({...e, group: d.scope}))
    }
    const enumInsideArray = Object.keys(enums)
      .filter((scope) => scopeWithoutRepeat(scope) === d.scope)
      .map((scope) => enums[scope].map(e=>({...e, group: scope})))

    if (enumInsideArray.length) {
      return flatten(enumInsideArray)
    }
    return undefined
  })

  const dynamicEnumOptions: iOption[] | undefined = enumsOption.some((e) => e === undefined)
    ? undefined
    : (flatten(enumsOption) as iOption[])

  return dynamicEnumOptions
}
